import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { ContractFilterInput } from '@/graphql/contracts/_generated_/contracts';
import {
  GetPaginatedFilteredContracts,
  GetPaginatedFilteredContractsVariables,
} from '@/graphql/contracts/_generated_/getPaginatedFilteredContracts.query';
import GetPaginatedContractsQuery from '@/graphql/contracts/getPaginatedFilteredContracts.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { PaginatedFilteredGridData } from '@/utils/data-helpers/PaginatedFilteredGridData';

export type PaginatedFilteredContracts = PaginatedFilteredGridData<ContractFilterInput>;

export default function useGetPaginatedFilteredContracts() {
  const [_getContracts] = useLazyQuery<
  GetPaginatedFilteredContracts,
  GetPaginatedFilteredContractsVariables
  >(GetPaginatedContractsQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'no-cache',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getPaginatedFilteredContracts = async (params: PaginatedFilteredContracts) => {
    const response = await _getContracts({
      variables: {
        ...params,
      } as GetPaginatedFilteredContractsVariables,
    });

    return response.data?.paginatedFilteredContracts;
  };

  return {
    getPaginatedFilteredContracts,
  } as const;
}
